import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          data-testid="error-boundary"
          style={{
            minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: '#f5f4ef', fontFamily: 'Inter, system-ui, sans-serif', padding: 20,
          }}
        >
          <div style={{ maxWidth: 460, background: '#fff', border: '1px solid rgba(0,0,0,.06)', borderRadius: 20, padding: 32, textAlign: 'center' }}>
            <div style={{ width: 48, height: 48, borderRadius: 14, background: '#1a1d1a', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 20, marginBottom: 16 }}>F</div>
            <h1 style={{ fontSize: 20, color: '#1a1d1a', margin: '0 0 8px' }}>Oups, une erreur est survenue</h1>
            <p style={{ color: '#666', fontSize: 14, margin: '0 0 20px' }}>
              Cette page a rencontré un problème inattendu. Rechargez la page ou revenez à l'accueil — vos données sont en sécurité.
            </p>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                data-testid="error-boundary-reload-btn"
                onClick={() => window.location.reload()}
                style={{ background: '#d97757', color: '#fff', border: 'none', borderRadius: 999, padding: '10px 22px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
              >
                Recharger la page
              </button>
              <button
                data-testid="error-boundary-home-btn"
                onClick={() => { window.location.href = '/'; }}
                style={{ background: '#fff', color: '#1a1d1a', border: '1px solid rgba(0,0,0,.15)', borderRadius: 999, padding: '10px 22px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
              >
                Retour à l'accueil
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
